/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'success-checkmark': {
    width: 120,
    height: 120,
    viewBox: '0 0 120 120',
    data: '<defs><linearGradient x1="0%" y1="50%" x2="100%" y2="50%" id="svgicon_success-checkmark_a"><stop stop-color="#FFA033" offset="0%"/><stop stop-color="#F24A30" offset="100%"/></linearGradient></defs><path pid="0" d="M60 0c33.137 0 60 26.863 60 60s-26.863 60-60 60S0 93.137 0 60 26.863 0 60 0zm22.879 41.879L53 71.757 39.121 57.879 34.88 62.12 53 80.243 87.121 46.12 82.88 41.88z" _fill="url(#svgicon_success-checkmark_a)" fill-rule="nonzero"/>'
  }
})
